<ui-wrapper class="flex items-center gap-4 py-4 max-[641px]:gap-2">
  <!-- Logo dle DNI var. A (DIAREZA-5905), rozměry a barva podle generátoru log DIA: JVS Modrá #00469B není v paletě
       gov.cz, proto natvrdo; v tmavém režimu bílé. Lev je CSS maska z assets/reza-logo.svg, barvu mu dává bg-current. -->
  <a
    [routerLink]="['/']"
    class="flex items-center gap-2.5 shrink-0 text-[#00469B] dark:text-white no-underline focus-visible:outline-2 focus-visible:outline-(--status-focus) focus-visible:outline-offset-4"
    aria-label="Registr zastupování – úvodní stránka">
    <span
      class="w-7.5 h-9.5 shrink-0 bg-current mask-[url(assets/reza-logo.svg)] mask-contain mask-no-repeat mask-center"
      aria-hidden="true"></span>
    <span class="flex flex-col text-(length:--font-size-body-m) font-normal leading-4.5">
      <span>Registr</span>
      <span>zastupování</span>
    </span>
  </a>
  @if (isTest) {
    <div class="ml-6 text-(length:--font-size-headline-s) font-bold">TEST</div>
  }

  <div class="flex items-center gap-4 ml-auto max-[641px]:gap-2">
    <a
      [routerLink]="dokumentaceLink"
      routerLinkActive="is-active"
      class="inline-flex items-center gap-2 p-2 rounded-(--corner-radius-s) text-(--text-primary-color) font-medium no-underline [&.is-active]:underline [&.is-active]:underline-offset-[0.25rem] hover:bg-(--button-outlined-primary-hover) focus-visible:outline-2 focus-visible:outline-(--status-focus) focus-visible:outline-offset-2"
      aria-label="Dokumentace">
      <i class="pi pi-book" aria-hidden="true"></i>
      <span class="max-[641px]:hidden">Dokumentace</span>
    </a>

    <!-- Skrytý panel šířky obsahu (easter egg, CONTENT_WIDTH_PANEL); pod 1024 px skryté -->
    @if (contentWidth.panelVisible()) {
      <button
        type="button"
        class="inline-flex max-lg:hidden items-center justify-center size-(--height-component-m) border-none rounded-(--corner-radius-s) text-(--text-primary-color) bg-transparent cursor-pointer hover:bg-(--button-outlined-primary-hover) [&.is-active]:bg-(--button-outlined-primary-hover) focus-visible:outline-2 focus-visible:outline-(--status-focus) focus-visible:outline-offset-2"
        [class.is-active]="contentWidth.isActive()"
        aria-label="Šířka obsahu"
        pTooltip="Šířka obsahu"
        tooltipPosition="bottom"
        aria-haspopup="dialog"
        (click)="widthPanel()?.toggle($event)">
        <i class="pi pi-arrows-h" aria-hidden="true"></i>
      </button>
    }

    <!-- Přepínač světlý / tmavý režim, ikona v táhle jako v gov.cz aplikacích -->
    <p-toggleswitch
      class="[--p-toggleswitch-handle-color:var(--icon-neutral)] [--p-toggleswitch-handle-checked-color:var(--icon-neutral)]"
      [ngModel]="darkMode.isDark()"
      (ngModelChange)="darkMode.setDark($event)"
      ariaLabel="Tmavý režim">
      <ng-template #handle let-checked="checked">
        <i
          class="pi text-(length:--icon-size-xs)"
          [class.pi-sun]="!checked"
          [class.pi-moon]="checked"
          aria-hidden="true"></i>
      </ng-template>
    </p-toggleswitch>

    @if (user(); as user) {
      <button
        type="button"
        class="flex items-center gap-2"
        [class]="userButtonClass"
        data-cy="header-user-menu"
        aria-haspopup="menu"
        [attr.aria-expanded]="userMenuOpen()"
        (click)="userMenu.toggle($event)">
        <i class="pi pi-briefcase text-(length:--icon-size-l)" aria-hidden="true"></i>
        <span class="flex flex-col min-w-0 ml-1 max-[641px]:hidden">
          <strong class="overflow-hidden text-(length:--font-size-body-s) font-bold whitespace-nowrap text-ellipsis"
            >{{ user.surname }} {{ user.name }}</strong
          >
          <span class="text-(length:--font-size-body-xs) leading-4.5">OVM: {{ user.ovmKod }}</span>
        </span>
        <i class="pi pi-chevron-down" aria-hidden="true"></i>
      </button>
      <p-menu
        #userMenu
        [model]="userMenuItems"
        [popup]="true"
        appendTo="body"
        (onShow)="userMenuOpen.set(true)"
        (onHide)="userMenuOpen.set(false)">
        <ng-template #start>
          <!-- Jméno a OVM v menu uživatele – jen na úzkých obrazovkách, kde je tlačítko bez popisku -->
          <div
            class="hidden max-[641px]:flex flex-col py-2 px-4 border-b border-(--component-nav-separator) text-(length:--font-size-body-s)">
            <strong>{{ user.surname }} {{ user.name }}</strong>
            <span class="text-(length:--font-size-body-xs)">OVM: {{ user.ovmKod }}</span>
          </div>
        </ng-template>
      </p-menu>

      <!-- Tlačítko hlavní navigace – jen pod MOBILE_NAV_BREAKPOINT (mobile-nav.service.ts, breakpoint nav v styles.css) -->
      <button
        type="button"
        class="hidden items-center justify-center max-nav:inline-flex size-(--height-component-m) border-none rounded-(--corner-radius-s) text-(--text-primary-color) bg-transparent text-(length:--icon-size-l) cursor-pointer hover:bg-(--button-outlined-primary-hover) focus-visible:outline-2 focus-visible:outline-(--status-focus) focus-visible:outline-offset-2"
        aria-label="Hlavní menu"
        (click)="toggleMobileNav($event)">
        <i class="pi pi-bars" aria-hidden="true"></i>
      </button>
    } @else {
      <!-- Třída logout-link je kontrakt pro e2e (stav nepřihlášeného: text „Přihlásit se“) -->
      <button
        type="button"
        class="logout-link flex items-center gap-2"
        [class]="userButtonClass"
        data-cy="header-login"
        (click)="login()">
        <i class="pi pi-user text-(length:--icon-size-l)" aria-hidden="true"></i>
        <span class="overflow-hidden text-(length:--font-size-body-s) font-bold whitespace-nowrap text-ellipsis"
          >Přihlásit se</span
        >
      </button>
    }
  </div>
</ui-wrapper>

<!-- Panel tlačítka „Šířka obsahu“ mimo řádek záhlaví (jako položka flexu by přidal mezeru) -->
@if (contentWidth.panelVisible()) {
  <p-popover #widthPopover (onShow)="pageType.set(contentWidth.pageType())">
    <div class="flex flex-col gap-2 max-w-80">
      <strong>Šířka obsahu</strong>
      <span class="text-(length:--font-size-body-s) text-(--text-secondary)">
        Výchozí je {{ contentFixedWidth ? 'max 1440 px na střed' : 'celá šířka okna' }}. Tato stránka:
        {{ pageTypeLabel[pageType()] }}.
      </span>
      @for (volba of widthOptions; track volba.id) {
        <label
          class="flex items-center gap-2 cursor-pointer has-[:disabled]:cursor-default has-[:disabled]:text-(--text-disabled)">
          <p-toggleswitch
            [inputId]="volba.id"
            [disabled]="contentWidth.isDisabled(volba.id)"
            [ngModel]="contentWidth.options[volba.id]()"
            (ngModelChange)="contentWidth.set(volba.id, $event)" />
          {{ volba.label }}
        </label>
      }
      <button pButton type="button" class="p-button-outlined self-start" (click)="hideWidthPanel()">
        Skrýt a obnovit výchozí
      </button>
    </div>
  </p-popover>
}
